// SearchInput組件翻譯
export default {
  // 標籤頁標題
  tabs: {
    canvasAnalysis: "畫布分析",
    dataDetail: "數據詳情",
    aiAssessment: "AI研判",
  },

  // 佔位符文本
  placeholders: {
    multiCurrency: "搜索地址 / 哈希 / 調證用戶ID",
    singleCurrency: "搜索地址 / 哈希",
  },

  // 畫布類型選項
  canvasTypes: {
    multi: "多幣種畫布",
    single: "單幣種畫布",
  },

  // 按鈕和操作
  actions: {
    search: "搜索",
    clear: "清除",
    exampleData: "示例數據",
  },

  // 提示信息
  messages: {
    noAddress: "沒有查出該地址",
    singleCurrencyUserNotSupported: "單幣種畫布暫不支持調證用戶查詢",
    userFunctionRestricted: "當前功能僅專業版用戶可用，請聯系客服諮詢。",
  },

  // 歷史記錄
  history: {
    loading: "加載中...",
    noHistory: "暫無歷史記錄",
  },
};
